import { allProductTypes } from "types/enums/Products/Products";
import { createResolver } from "./Factories/ResolverFactory";
import type { Elements } from "@kontent-ai/delivery-sdk";
import { Products } from "types/CMS/KontentAI/taxonomies/products";

export const productTaxonomyResolver = createResolver({
  resolve: (
    products: Elements.TaxonomyElement<Products, "products">,
  ): allProductTypes[] => {
    if (products?.value === undefined || products?.value?.length === 0) {
      return [];
    }
    return products.value
      .map((product) => {
        return mapKontentProductToUnum(product.codename);
      })
      .filter((item) => item !== undefined);
  },
});

const mapKontentProductToUnum = (
  product: Products,
): allProductTypes | undefined => {
  switch (product) {
    case "cash_plan":
      return "cashPlan";
    case "group_income_protection":
      return "GIP";
    case "group_life":
      return "GL";
    case "critical_illness":
      return "CIC";
    case "help_at_hand_sso":
      return "help@hand_SSO";
    default:
      return undefined;
  }
};
